import { Baskervville } from 'next/font/google';
import { useEffect, useState } from 'react';

import { useConfig } from 'context/useConfig';

const baskervville = Baskervville({
  subsets: ['latin'],
  weight: ['400'],
  display: 'swap',
});

function getGreeting(): string {
  const hour = new Date().getHours();

  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';

  return 'Good evening';
}

export const HomeGreeting = () => {
  const { user } = useConfig();

  const firstName = user?.name?.split(' ')[0] ?? '';

  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    setGreeting(getGreeting());
  }, []);

  if (!greeting) return null;

  return (
    <h1
      className={`text-3xl leading-8 font-medium text-text-primary ${baskervville.className}`}
    >
      {firstName ? `${greeting}, ${firstName}` : greeting}
    </h1>
  );
};
